import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import {
    arrayOfStringsToStringWithSeparator,
    capitalizeFirstLetterOfEachWord,
    toTitleCase,
    upperCaseAll,
    prettifyCardNumber,
    prettifyDate
} from '../../utils/string';
import {
    getTransaction,
    getIsTransactionLoading,
    getTransactionErrorMessage,
    getIsLinkedRefundLoading,
    getLinkedRefunds
} from './transactionEntity';
import { toggleModal } from '../Modal/modalActions';
import { getMerchantsMapper } from '../Merchants/merchantsEntity';
import {
    getIsCaptureSuccessfulById,
    getCaptureErrorMessageById,
    getAmountCapturedById
} from '../Capture/captureEntity';
import {
    getIsVoidSuccessfulById,
    getVoidErrorMessageById
} from '../Void/voidEntity';
import {
    getIsRefundSuccessfulById,
    getRefundErrorMessageById
} from '../Refund/refundEntity';
import {
    getTransaction as queryForTransaction,
    checkForLinkedRefunds
} from './transactionActions';
import {
    EmvioCard,
    EmvioLoadingSpinner as LoadingSpinner,
    EmvioRow,
    EmvioTwoColumnItem
} from '@nexio/emvio-util-ui';
import {
    cardTypesShape,
    transactionShape
} from '../../utils/propTypes';
import {
    cardTypesMapper,
    cardClassesMapper,
    currencyMapper,
    doesPropExistAndHasItChanged,
    processMethodMapper,
    transactionStatusMapper,
    transactionTypeMapper,
    prettifyMoney,
    processMethod,
    transactionStatus,
    kountThresholds,
    processingOptionsPaymentTypes,
    transactionStatus as transactionStatuses
} from '@nexio/emvio-util-app';
import { fraudMapper } from '../Fraud/Fraud';
import Actions from './Actions/Actions';
import { toastIfError } from '../../utils/toast';
import { flattenObjectRecursive } from '../../utils/flattenObject';
import {
    get,
    isNumber,
    isNull,
    startCase,
    forEach
} from 'lodash';
import ErrorCard from '../ErrorCard/ErrorCard';
import mixpanel from '../../utils/mixpanel';
import { getHoursLeftToAutoApprove } from '../Fraud/Fraud';
import { getBatchOfTransactionsLink } from '../Transactions/transactionsActions';
import './Transaction.scss';
import _ from 'lodash';
import { Link } from 'react-router-dom';
import { getTransactionLink, getChargebackLink } from '../Search/searchActions';
import { doesRoleHaveAccessToFeature } from '../../utils/customRole';
import config from '../../config/config';
import { getCustomAccess } from '../Self/selfEntity';
import { localGatewayAndApmMapper } from '../../utils/gateways';
import { getGateways } from '../Gateways/gatewaysEntity';
import { getApms } from '../Apms/apmEntity';
import { isKount360 } from '../../utils/gateways';

export class Transaction extends Component {
    static propTypes = {
        amountCaptured: PropTypes.number,
        cardTypes: PropTypes.arrayOf(cardTypesShape),
        error: PropTypes.string,
        isTransactionLoading: PropTypes.bool,
        isCaptureSuccessful: PropTypes.bool,
        isRefundSuccessful: PropTypes.bool,
        isVoidSuccessful: PropTypes.bool,
        captureError: PropTypes.string,
        refundError: PropTypes.string,
        voidError: PropTypes.string,
        match: PropTypes.shape({
            isExact: PropTypes.bool,
            params: PropTypes.shape({
                id: PropTypes.string
            }),
            path: PropTypes.string,
            url: PropTypes.string
        }),
        merchantMap: PropTypes.any,
        onGetTransactionById: PropTypes.func,
        onGoBack: PropTypes.func,
        transaction: transactionShape,
        onToggleModal: PropTypes.func,
        customAccess: PropTypes.any,
        linkedRefunds: PropTypes.arrayOf(PropTypes.any),
        isLinkedRefundsLoading: PropTypes.bool,
        onGetLinkedRefunds: PropTypes.func,
        gateways: PropTypes.shape({
            gatewayList: PropTypes.object,
            gatewaysThatCanCapture: PropTypes.array,
            gatewaysThatCanRefund: PropTypes.array,
            gatewaysThatCanVoid: PropTypes.array
        }),
        apms: PropTypes.array
    };

    constructor(props) {
        super(props);

        this.state = {};
    }

    componentDidMount() {
        this.props.onGetTransactionById(this.props.match.params.id);
        mixpanel.track('Transaction page mounted');
    }

    componentDidUpdate(prevProps) {
        toastIfError(prevProps, this.props);
        toastIfError(prevProps, this.props, 'captureError');
        toastIfError(prevProps, this.props, 'refundError');
        toastIfError(prevProps, this.props, 'voidError');

        if (doesPropExistAndHasItChanged(prevProps, this.props, 'isRefundSuccessful')
            || doesPropExistAndHasItChanged(prevProps, this.props, 'isVoidSuccessful')
            || doesPropExistAndHasItChanged(prevProps, this.props, 'isCaptureSuccessful')
        ) {
            this.props.onGetTransactionById(this.props.match.params.id);
        }

        if (doesPropExistAndHasItChanged(prevProps, this.props, 'isRefundSuccessful')) {
            this.props.onGetLinkedRefunds(this.props.transaction);
        }

        if (doesPropExistAndHasItChanged(prevProps, this.props, 'isCaptureSuccessful')) {
            this.setState({ uiCaptureEdit: true });
        }

        if (doesPropExistAndHasItChanged(prevProps, this.props, 'refundError')) {
            this.props.onToggleModal('refund');
        }

        if (doesPropExistAndHasItChanged(prevProps, this.props, 'transaction')) {
            this.setState({ chargebackId: _.get(this.props, 'transaction.linkedChargebackId') });
            this.props.onGetLinkedRefunds(this.props.transaction);
        }

        if (doesPropExistAndHasItChanged(prevProps, this.props, 'match.params.id')) {
            this.props.onGetTransactionById(this.props.match.params.id);
        }
    }
    renderTransactionResult() {
        const fraudStatus = get(this.props.transaction, 'kount.status');
        const transactionStatus = get(this.props.transaction, 'transactionStatus');
        let message = (transactionStatuses.declined === transactionStatus) || (transactionStatuses.error === transactionStatus) ?
            get(this.props.transaction, 'gateway.message')
            : null;
        const achDetailId = this.props.transaction.achDetailId;
        let kountId;
        let kountData;
        try {
            kountData = JSON.parse(get(this.props, 'transaction.kount.rules'));
            if (isKount360(kountData)) {
                kountId = _.get(kountData, 'order.orderId');
            } else {
                kountId = _.get(kountData, 'TRAN');
            }
        } catch (err) {
            kountId = undefined;
        }

        const items = [
            {
                alterMethod: capitalizeFirstLetterOfEachWord,
                label: 'Type',
                value: transactionTypeMapper[this.props.transaction.transactionType]
            },
            {
                label: 'Gateway Reference Number',
                value: get(this.props.transaction, 'gateway.refNumber')
            },
            {
                label: 'Additional Reference Number',
                value: get(this.props.transaction, 'gateway.additionalRefNumber')
            },
            {
                label: 'Order ID',
                value: get(this.props.transaction, 'plugin.orderNumber')
            },
            {
                label: 'Authorization Code',
                value: this.props.transaction.authCode
            },
            {
                label: 'Deposit Detail ID',
                breakAll: true,
                value: achDetailId ?
                    <a href={getBatchOfTransactionsLink(achDetailId, this.props.transaction.transactionDate)}>{achDetailId}</a>
                    : null
            },
            {
                label: 'Gateway Batch ID',
                value: get(this.props.transaction, 'gateway.batchRef')
            },
            {
                label: 'Processor Batch ID',
                value: get(this.props.transaction, 'processor.batchRef')
            },
            {
                alterMethod: startCase,
                label: 'Status',
                value: transactionStatusMapper[transactionStatus]
            },
            {
                alterMethod: capitalizeFirstLetterOfEachWord,
                label: 'Message',
                value: message
            },
            {
                alterMethod: capitalizeFirstLetterOfEachWord,
                label: 'Fraud Status',
                value: fraudMapper[get(this.props.transaction, 'kount.status')]
            },
            {
                label: 'Kount ID',
                value: kountId
            },
            {
                label: 'Auto Approve Time',
                value: fraudStatus === 'R' && transactionStatusMapper[transactionStatus] === 'authOnly' ? getHoursLeftToAutoApprove(get(this.props.transaction, 'transactionDate')) : null
            },
            {
                label: 'Payment ID',
                value: get(this.props.transaction, 'plugin.originalId'),
                breakAll: true
            },
            {
                label: 'Acquirer Reference Number (ARN)',
                value: get(this.props.transaction, 'processor.transactionRef')
            }
        ];

        return this.renderCard(items, 'Transaction Results');
    }

    renderBillingAddress = () => {
        const {
            billingAddressOne,
            billingAddressTwo,
            billingCity,
            billingState,
            billingPostalCode,
            billingCountry,
            billingPhone
        } = _.get(this.props, 'transaction.customerAddresses') || {};

        const items = [
            {
                label: 'Address 1',
                value: billingAddressOne
            },
            {
                label: 'Address 2',
                value: billingAddressTwo
            },
            {
                label: 'City',
                value: billingCity
            },
            {
                label: 'State',
                value: billingState
            },
            {
                label: 'Postal Code',
                value: billingPostalCode
            },
            {
                label: 'Country',
                value: billingCountry
            },
            {
                label: 'Phone',
                value: billingPhone
            }
        ];

        return this.renderCard(items, 'Billing Address');
    };

    renderShippingAddress = () => {
        const {
            shippingAddressOne,
            shippingAddressTwo,
            shippingCity,
            shippingState,
            shippingPostalCode,
            shippingCountry,
            shippingPhone
        } = _.get(this.props, 'transaction.customerAddresses') || {};

        const items = [
            {
                label: 'Address 1',
                value: shippingAddressOne
            },
            {
                label: 'Address 2',
                value: shippingAddressTwo
            },
            {
                label: 'City',
                value: shippingCity
            },
            {
                label: 'State',
                value: shippingState
            },
            {
                label: 'Postal Code',
                value: shippingPostalCode
            },
            {
                label: 'Country',
                value: shippingCountry
            },
            {
                label: 'Phone',
                value: shippingPhone
            }
        ];

        return this.renderCard(items, 'Shipping Address');
    };

    renderSubscriptionInfo = () => {
        const {
            remainingBalance,
            initialBalance,
            interval,
            intervalCount,
            subscriptionRef,
            scheduleType
        } = _.get(this.props, 'transaction.subscription') || {};
        if (!subscriptionRef) {
            return;
        }
        const currencyId = _.get(this.props, 'transaction.currencyId');
        const currencyCode = currencyId ? currencyMapper[currencyId].code.toUpperCase() : null;
        const subscriptionType = scheduleType === 10 ? 'Pay Plan' : 'Subscription';

        const items = [
            {
                label: 'Type',
                value: subscriptionType
            },
            {
                alterMethod: ((amount) => prettifyMoney(amount, currencyCode)),
                label: 'Remaining Balance',
                value: remainingBalance
            },
            {
                alterMethod: ((amount) => prettifyMoney(amount, currencyCode)),
                label: 'Initial Balance',
                value: initialBalance
            },
            {
                label: 'Interval',
                value: interval
            },
            {
                label: 'Interval Count',
                value: intervalCount
            },
            {
                label: 'Subscription ID',
                value: subscriptionRef
            }
        ];

        return this.renderCard(items, 'Subscription Info');
    };

    renderCustomFields() {
        const {
            customFields
        } = _.get(this.props, 'transaction.transactionDetails') || {};
        let customFieldsObj;
        try {
            customFieldsObj = JSON.parse(customFields);
        } catch (e) {
            return;
        }

        const flattenedCustomFieldsObj = flattenObjectRecursive(customFieldsObj, '.');

        const items = [];
        _.forEach(flattenedCustomFieldsObj, (value, label) => {
            items.push({ label, value });
        });

        return this.renderCard(items, 'Custom Fields');
    }

    renderTransactionId(id) {
        return (<Link className="transaction-clickthrough-link" to={getTransactionLink({ id })}>{id}</Link>);
    }

    renderChargebackId = (id) => {
        if (doesRoleHaveAccessToFeature(this.props.customAccess, { [config.serviceArns.chargeback]: ['GET/v3/{id}'] })) {
            return (<Link className="chargeback-clickthrough-link" to={getChargebackLink(id)}>{id}</Link>);
        } else {
            return id;
        }
    };

    renderRelatedActivity() {
        const items = [];

        items.push({
            alterMethod: this.renderTransactionId,
            label: 'Original Transaction ID',
            value: _.get(this.props, 'transaction.originalTransactionId')
        });

        items.push({
            alterMethod: this.renderChargebackId,
            label: 'Linked Chargeback ID',
            value: this.state.chargebackId
        });

        if (this.props.linkedRefunds) {
            this.props.linkedRefunds.forEach((linkedRefund) => {
                items.push({
                    alterMethod: this.renderTransactionId,
                    label: 'Linked Refund ID',
                    value: _.get(linkedRefund, 'id')
                });
            });
        }

        return this.renderCard(items, 'Related Activity');
    }

    renderSettledAmount(amount, currencyCode) {
        return isNumber(amount) ? prettifyMoney(amount, currencyCode) : amount;
    }

    renderPaymentType(paymentType) {
        const mappedPaymentType = processingOptionsPaymentTypes[paymentType];

        switch (mappedPaymentType) {
            case 10:
                return 'Initial Scheduled';
            case 30:
                return 'Initial Unscheduled';
            case 60:
                return 'Initial MOTO';
            case 70:
                return 'MOTO';
            case 20:
                return 'Scheduled';
            case 40:
                return 'Unscheduled CIT';
            case 50:
                return 'Unscheduled MIT';
            default:
                return 'unavailable';
        }
    }

    renderTransactionInfo() {
        const settledCurrencyId = get(this.props.transaction, 'currencyId', '840');
        const settledCurrencyCode = currencyMapper[settledCurrencyId].code.toUpperCase();
        const processedCurrencyId = get(this.props.transaction, 'foreignProcessingCurrency.currencyId');
        const processedCurrencyCode = processedCurrencyId ? currencyMapper[processedCurrencyId].code.toUpperCase() : null;
        const isAmountNull = isNull(this.props.transaction.amount);
        const status = get(this.props.transaction, 'transactionStatus');
        const paymentType = get(this.props, 'transaction.transactionDetails.paymentType');
        const installments = get(this.props, 'transaction.transactionDetails.installments') ? get(this.props, 'transaction.transactionDetails.installments') : undefined;
        const installmentUnit = get(this.props, 'transaction.transactionDetails.installmentUnit') ? get(this.props, 'transaction.transactionDetails.installmentUnit') : undefined;
        const installmentPeriod = installments && installmentUnit ? `${installments} ${installmentUnit}` : undefined;

        const surcharge = get(this.props, 'transaction.transactionDetails.surcharge') === null ? undefined : get(this.props, 'transaction.transactionDetails.surcharge');

        let settledAmount;

        if (isAmountNull) {
            if (status === transactionStatus.settled) {
                settledAmount = 'Settlement amount not available';
            } else {
                settledAmount = 'Pending...';
            }
        } else if (this.state.uiCaptureEdit) {
            settledAmount = this.props.amountCaptured === null ? this.props.transaction.amount : this.props.amountCaptured * 1;
        } else {
            settledAmount = this.props.transaction.amount;
        }

        const items = [
            {
                label: 'Nexio Transaction ID',
                value: this.props.transaction.id
            },
            {
                alterMethod: ((transactionDate) => prettifyDate(transactionDate)),
                label: 'Transaction Date',
                value: this.props.transaction.transactionDate
            },
            {
                alterMethod: ((settledDate) => prettifyDate(settledDate)),
                label: 'Settled Date',
                value: this.props.transaction.settledDate
            },
            {
                alterMethod: ((reportDate) => prettifyDate(reportDate, { returnDateOnly: true })),
                label: 'Statement Date',
                value: this.props.transaction.reportDate
            },
            {
                label: 'Invoice',
                value: get(this.props.transaction, 'plugin.invoice')
            },
            {
                alterMethod: upperCaseAll,
                label: 'Currency',
                value: this.props.transaction.currencyCode
            },
            {
                alterMethod: ((amount) => this.renderSettledAmount(amount, settledCurrencyCode)),
                label: 'Amount',
                value: settledAmount
            },
            {
                alterMethod: ((surcharge) => this.renderSettledAmount(surcharge, settledCurrencyCode)),
                label: 'Surcharge',
                value: surcharge
            },
            {
                label: 'Currency Code',
                value: settledCurrencyCode
            },
            {
                alterMethod: ((amount) => prettifyMoney(amount, processedCurrencyCode)),
                label: 'Processed Amount',
                value: this.state.uiCaptureEdit && isAmountNull ? this.props.amountCaptured * 1 : get(this.props.transaction, 'foreignProcessingCurrency.amount')
            },
            {
                label: 'Processed Currency Code',
                value: processedCurrencyCode
            },
            {
                alterMethod: startCase,
                label: 'Method',
                value: processMethodMapper[get(this.props, 'transaction.processMethod')]
            },
            {
                label: 'Description',
                value: get(this.props.transaction, 'plugin.description')
            },
            {
                label: 'Merchant',
                value: this.props.merchantMap[get(this.props.transaction, 'merchantId')]
            },
            {
                label: 'Merchant ID',
                value: get(this.props.transaction, 'merchantId')
            },
            {
                alterMethod: upperCaseAll,
                label: 'Gateway',
                value: localGatewayAndApmMapper(this.props.gateways, this.props.apms)[get(this.props.transaction, 'gateway.gatewayType')]
            },
            {
                label: 'User',
                value: _.get(this.props, 'transaction.transactionDetails.userName')
            },
            {
                label: 'Payment Option Tag',
                value: _.get(this.props, 'transaction.plugin.paymentOptionTag')
            },
            {
                alterMethod: ((paymentType) => this.renderPaymentType(paymentType)),
                label: 'Payment Type',
                value: paymentType
            },
            {
                label: 'Installment Period',
                value: installmentPeriod
            }
        ];

        return this.renderCard(items, 'Transaction Information');
    }

    renderPaymentMethod() {
        const cardProcessMethods = [processMethod.card, processMethod.cardNotPresent, processMethod.cardPresent];
        const items = [
            {
                alterMethod: capitalizeFirstLetterOfEachWord,
                label: get(this.props.transaction, 'cardNumber') || _.includes(cardProcessMethods, get(this.props.transaction, 'processMethod')) ? 'Card Holder' : 'Account Holder',
                value: get(this.props.transaction, 'cardHolder')
            },
            {
                alterMethod: capitalizeFirstLetterOfEachWord,
                label: 'Card Type',
                value: cardTypesMapper[get(this.props.transaction, 'cardType')]
            },
            {
                alterMethod: prettifyCardNumber,
                label: 'Card Number',
                value: get(this.props.transaction, 'cardNumber')
            },
            {
                label: 'Account Number',
                value: get(this.props.transaction, 'bankTransfer.account')
            },
            {
                label: 'Routing Number',
                value: get(this.props.transaction, 'bankTransfer.routing')
            },
            {
                label: 'Payment Token',
                value: get(this.props.transaction, 'transactionDetails.paymentToken')
            },
            {
                label: 'Card Class',
                value: _.toUpper(cardClassesMapper[get(this.props.transaction, 'cardMetaData.class')])
            },
            {
                label: 'Issuing Bank',
                value: get(this.props.transaction, 'cardMetaData.issuingBank')
            }
        ];

        return this.renderCard(items, 'Payment Method');
    }

    renderActions() {

        return (
            <EmvioRow>
                <Actions
                    className="actions"
                    transaction={this.props.transaction}
                    isCaptured={this.props.isCaptureSuccessful}
                    isVoided={this.state.uiVoidEdit}
                    isFullyRefunded={checkFullRefunds(this.props.transaction, this.props.linkedRefunds)}
                    chargeback={this.state.chargebackId}
                    isChargebackLoading={this.props.isTransactionLoading}
                    isLinkedRefundsLoading={this.props.isLinkedRefundsLoading}
                />
            </EmvioRow>
        );
    }

    renderFraudDetails() {
        const failedRulesString = get(this.props.transaction, 'kount.rules') || {};
        let failedRulesObject = {};
        try {
            failedRulesObject = JSON.parse(failedRulesString);
        } catch (error) {
            // Swallow errors
        }

        if (isKount360(failedRulesObject)) {
            try {
                const kount360Rules = {};
                let i = 0;
                const policiesExecuted = _.get(failedRulesObject, 'order.riskInquiry.segmentExecuted.policiesExecuted', []);
                const addRule = (id, desc) => {
                    kount360Rules[`RULE_ID_${i}`] = id;
                    kount360Rules[`RULE_DESCRIPTION_${i}`] = desc;
                    i++;
                };

                _.forEach(policiesExecuted, ({ name, outcome }) => {
                    const value = _.trim(_.get(outcome, 'value'));
                    const ruleText = value
                        ? `${toTitleCase(name)} (${toTitleCase(value)})`
                        : toTitleCase(name);
                    addRule(name, ruleText);
                });

                failedRulesObject = { ...failedRulesObject, ...kount360Rules };
            } catch (err) {
                // Swallow errors
            }
        }

        let brokenRuleDescriptors = Object.keys(failedRulesObject)
            .filter((key) => key.includes('RULE_ID'))
            .map((idKey) => {
                const ruleNumber = idKey.substr(8, idKey.length);
                const descriptionKey = `RULE_DESCRIPTION_${ruleNumber}`;
                const ruleDescription = failedRulesObject[descriptionKey];

                return ruleDescription ? ruleDescription : `Rule ID: ${failedRulesObject[idKey]}, no description given`;
            });

        const kountCentralBrokenRuleDescriptors = Object.keys(failedRulesObject)
            .filter((key) => (/KC_EVENT_\d+_CODE/.test(key)))
            .map((key) => `${kountThresholds[failedRulesObject[key]]} ${failedRulesObject[key.replace('CODE', 'EXPRESSION')]}`);

        brokenRuleDescriptors = brokenRuleDescriptors.concat(kountCentralBrokenRuleDescriptors);
        if (brokenRuleDescriptors.length) {
            return (
                <div className="transaction-fraud-card">
                    <div className="fraud-rules-header">Fraud Rules Triggered</div>
                    <div className="fraud-rules-container">
                        {brokenRuleDescriptors.map((descriptor) => (
                            <div key={descriptor} className="fraud-rule">{descriptor}
                            </div>))}
                    </div>
                </div>
            );
        } else {
            return null;
        }
    }

    renderCard(items, headerTitle) {
        if (items.some((item) => (item.value))) {
            return (
                <EmvioCard className="half-width grow-height" HeaderComponent={headerTitle}>
                    {items.map((item) =>
                        <EmvioTwoColumnItem
                            key={item.label}
                            alterMethod={item.alterMethod}
                            label={item.label}
                            value={item.value}
                            breakAll={item.breakAll}
                        />
                    )}
                </EmvioCard>);
        } else {
            return null;
        }
    }

    renderCustomerInfo() {
        const { customer } = this.props.transaction;
        const customerName = arrayOfStringsToStringWithSeparator([customer.firstName, customer.lastName]);
        const items = [
            {
                alterMethod: capitalizeFirstLetterOfEachWord,
                label: 'Name',
                value: customerName
            },
            {
                label: 'Phone Number',
                value: get(customer, 'phone')
            },
            {
                label: 'Email',
                value: get(customer, 'email')
            },
            {
                label: 'Customer ID',
                value: get(customer, 'customerRef')
            },
            {
                label: 'Client IP Address',
                value: _.get(this.props, 'transaction.transactionDetails.clientIp')
            }
        ];

        return this.renderCard(items, 'Customer Information');
    }

    renderECheckDisclaimer() {
        const { transactionStatus, processMethod } = this.props.transaction;
        if (processMethod === 40) {
            const disclaimers = [
                'Transactions can take up to 7 business days to settle.',
                'Funds for pending and submitted transactions are not guaranteed before settlement.',
                'Transactions are handled through a third party service and do not show up in the Deposit Summary, Batch Details or Statements reports.'
            ];
            const items = (transactionStatus === 12 || transactionStatus === 13)
                ? disclaimers
                : [disclaimers[2]];

            return (
                <EmvioRow>
                    <EmvioCard className="grow-height full-width" HeaderComponent="eCheck Disclaimer">
                        <ul className="transaction-disclaimer-header">
                            {items.map((item) => (
                                <li key={item} className="transaction-disclaimer-row">{item}</li>
                            ))}
                        </ul>
                    </EmvioCard>
                </EmvioRow>
            );
        }
    }

    render() {
        if (this.props.isTransactionLoading) {
            return (<LoadingSpinner />);
        } else if (this.props.transaction && !this.props.error) {
            let cards = [];
            cards.push(this.renderTransactionResult());
            cards.push(this.renderTransactionInfo());
            cards.push(this.renderPaymentMethod());

            const customer = get(this.props, ['transaction', 'customer'], null);
            if (customer) {
                cards.push(this.renderCustomerInfo());
            }

            const fraudDetailsCard = this.renderFraudDetails();

            cards.push(this.renderBillingAddress());
            cards.push(this.renderShippingAddress());
            cards.push(this.renderSubscriptionInfo());
            cards.push(this.renderCustomFields());
            cards.push(this.renderRelatedActivity());

            cards = _.compact(cards);

            const cardRows = _.chunk(cards, 2).map((cardPair, index) => {
                return (
                    // eslint-disable-next-line @eslint-react/no-array-index-key
                    <EmvioRow key={index}>
                        {cardPair[0]}
                        {cardPair[1]}
                    </EmvioRow>
                );
            });

            return (
                <div className="emvio-transaction">
                    {   // once we support reverse ACH then we can remove the ternary and allow void/refund
                        this.props.transaction.processMethod !== processMethod.eCheck ? this.renderActions() : null
                    }
                    {this.renderECheckDisclaimer()}
                    <EmvioRow>
                        {fraudDetailsCard}
                    </EmvioRow>
                    {cardRows}
                </div>
            );
        } else {
            return (
                <div className="emvio-transaction">
                    <EmvioRow>
                        <ErrorCard />
                    </EmvioRow>
                </div>
            );
        }
    }
}

function mapStateToProps(state) {
    const transaction = getTransaction(state);
    const transactionId = get(transaction, 'id');

    return {
        amountCaptured: getAmountCapturedById(state, transactionId),
        error: getTransactionErrorMessage(state),
        isTransactionLoading: getIsTransactionLoading(state),
        isCaptureSuccessful: getIsCaptureSuccessfulById(state, transactionId),
        isRefundSuccessful: getIsRefundSuccessfulById(state, transactionId),
        isVoidSuccessful: getIsVoidSuccessfulById(state, transactionId),
        captureError: getCaptureErrorMessageById(state, transactionId),
        refundError: getRefundErrorMessageById(state, transactionId),
        voidError: getVoidErrorMessageById(state, transactionId),
        merchantMap: getMerchantsMapper(state),
        transaction: getTransaction(state),
        customAccess: getCustomAccess(state),
        linkedRefunds: getLinkedRefunds(state),
        isLinkedRefundsLoading: getIsLinkedRefundLoading(state),
        gateways: getGateways(state),
        apms: getApms(state)
    };
}

function mapDispatchToProps(dispatch) {
    return {
        onGetTransactionById: (id) => dispatch(queryForTransaction(id)),
        onGetLinkedRefunds: (transaction) => dispatch(checkForLinkedRefunds(transaction)),
        onToggleModal: (type) => dispatch(toggleModal(type))
    };
}

export function checkFullRefunds(transaction, linkedRefunds) {
    let totalRefundAmt = 0;
    const amount = _.get(transaction, 'foreignProcessingCurrency.amount', _.get(transaction, 'amount'));

    if (linkedRefunds && linkedRefunds.length !== 0) {
        forEach(linkedRefunds, (refund) => {
            const linkedRefundsAmount = Math.abs(_.get(refund, 'foreignProcessingCurrency.amount', _.get(refund, 'amount')));
            if (linkedRefundsAmount) {
                totalRefundAmt += linkedRefundsAmount;
            }
        });
        if (totalRefundAmt >= amount) {
            return true;
        }
    }

    return false;
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Transaction));
